import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearListsFilters,
  DescriptionChanged,
  GetTargetsSuccess,
  NameChanged,
  PanelStatusChanged,
  TargetChanged,
} from '../actions/lists.actions';

export interface ListsState {
  panelExpanded: boolean;
  name: string | null;
  description: string | null;
  target: string | null;
  targets: string[];
}

const initialState: ListsState = {
  panelExpanded: true,
  name: null,
  description: null,
  target: null,
  targets: [],
};

export const ListsReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(NameChanged, (state, { name }) => ({
    ...state,
    name: name ? name : null,
  })),
  on(DescriptionChanged, (state, { description }) => ({
    ...state,
    description: description ? description : null,
  })),
  on(TargetChanged, (state, { target }) => ({
    ...state,
    target: target ? target : null,
  })),
  on(GetTargetsSuccess, (state, { res }) => ({
    ...state,
    targets: res.campaignSelectionTargetEnum.filter(
      (item: string) => item === 'LOYALTYMEMBER' || item === 'PERSON',
    ),
  })),
  on(ClearListsFilters, (state) => ({
    ...state,
    name: null,
    description: null,
    target: null,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    name: null,
    description: null,
    target: null,
  })),
  on(ResetStateFromRouter, () => ({
      ...initialState
  }))
);
